import { Button } from 'antd';
import { showConfirm } from 'presentation/redux/features/app/appSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Mock } from '../models/Mock';

export const CardComponent = (props: Mock) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userSlice = useAppSelector((state) => state.user);
    return (
        <Button
            className="card-element button-style glow-on-hover"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            onClick={() => {
                if (!userSlice?.isSignedIn && props.title.includes('くわしく査定')) {
                    const confirmProps = {
                        message: '以降のステップには\nログインが必要です。',
                        okText: 'ログイン・アカウント作成へ',
                        cancelText: 'いいえ',
                        type: 'info',
                        onOk: () => navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`),
                    };
                    dispatch(showConfirm(confirmProps));
                } else {
                    navigate(`${PRIVATE_ROUTES.PATH}/${props.redirect}`);
                }
            }}
        >
            {props.image}
            <div
                style={{
                    height: '100%',
                    width: 239,
                }}
            >
                <p className="title">{props.title}</p>
                <p className="description">
                    {props.description.map((text, index) => (
                        <React.Fragment key={index}>
                            {text}
                            <br />
                        </React.Fragment>
                    ))}
                </p>
            </div>
        </Button>
    );
};
